import type { GetSalesTransactionsQuery } from './queries';
import type {
    GetSalesTransactionsResponse,
    CreateSalesTransactionResponse,
} from './responses';
import type { CreateSalesTransactionRequest } from './requests';
import { SalesEndpoints } from './salesEndpoints';
import type { ISalesService } from './ISalesService';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import { getAxiosClient } from '../../client';

type SalesServiceOptions = {
    baseUrl: string;
};

export class SalesService implements ISalesService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: SalesServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public createSalesTransaction(
        body: CreateSalesTransactionRequest,
    ): Promise<ApiResponse<CreateSalesTransactionResponse>> {
        // POST commits the cart as a completed sale; bos-api resolves prices,
        // decrements stock (FIFO), and returns the persisted receipt (201).
        const url = SalesEndpoints.salesTransactions();
        return makeApiRequest<CreateSalesTransactionResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).post(url, body),
        );
    }

    public async getSalesTransactions(
        query: GetSalesTransactionsQuery,
    ): Promise<ApiResponse<GetSalesTransactionsResponse>> {
        // bos-api binds query params PascalCase (`From`, `To`, `Page`,
        // `PageSize`, `SellerName`); axios-case-converter rewrites the
        // camelCase keys we send into PascalCase on the wire, and the
        // response back into camelCase on the way in.
        const url = SalesEndpoints.salesTransactions();
        const httpRequest = getAxiosClient({ baseURL: this.baseUrl }).get(url, {
            params: query,
        });
        const result =
            await makeApiRequest<GetSalesTransactionsResponse>(httpRequest);
        return result;
    }
}
